<template>
  <div class="bg-gray-200 min-h-screen w-full px-4 md:px-8 lg:pl-28 lg:pr-10 py-4 flex flex-col">
    <!-- Header -->
    <header class="flex flex-col md:flex-row md:items-center justify-between mb-4">
      <h1 class="text-2xl md:text-3xl font-bold text-center md:text-left">Email Report</h1>
      <searchAutoFill class="searchButton w-[30px] sm:w-64 ml-4 md:w-72 mt-2 md:mt-0" @update-domain="updateDomain" />
    </header>

    <email-dashboard @update-dates="updateDates" class="hidden" />

    <!-- Summary Section -->
    <div v-if="Object.keys(reportData).length" class="bg-white p-3  rounded-lg shadow-lg w-full h-[30hv]">
      <p class="text-sm md:text-base font-semibold text-gray-700 text-center md:text-left">
        Domain: {{ selectedDomain }}
      </p>
      <h2 class="text-sm md:text-base font-semibold mt-1 text-center md:text-left">
        From: &nbsp;&nbsp;&nbsp;&nbsp;{{ getDisplayTime(fromDate) }}
      </h2>
      <h2 class="text-sm md:text-base font-semibold mt-1 text-center md:text-left">
        To: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ getDisplayTime(toDate) }}
      </h2>

      <!-- Circular Progress Bars Grid -->
      <div class="mt-2 flex flex-wrap  gap-4 py-2 px-8">
        <div 
          v-for="(stat, key) in reportStats" 
          :key="key" 
          class="bg-white p-8 rounded-lg shadow-lg flex flex-col w-[230px] px-10 py-8 items-start "
        >
          <p class="text-l md:text-sm text-gray-800">{{ stat.label }}</p>
          <div class="flex items-baseline gap-2 mt-2">
            <h2 class="text-xxl md:text-2xl font-semibold">{{ reportData[stat.key] || 0 }}</h2>
            <span
              v-if="typeof reportData[stat.key] === 'number' && typeof reportData.total_emails === 'number'"
              :class="[
                'text-l md:text-sm font-semibold ml-14',
                getPercentage(reportData[stat.key], reportData.total_emails) >= 0
                  ? 'text-green-500'
                  : 'text-red-500'
              ]"
            >
              {{ getPercentage(reportData[stat.key], reportData.total_emails) }}%
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden inboxTable to fetch data -->
    <inbox-table
      ref="inboxTableRef"
      :domainName="selectedDomain"
      :selectedPeriod="selectedPeriod"
      @update-report="handleReportUpdate"
      @update-gmail-data="updateGmailData"
      @update-dates="updateDates"
      class="hidden"
    />

    <!-- Line Chart -->
    <line-chart :gmailInboxData="gmailInboxData" class="line-chart mt-4 lg:mt-2 flex-grow" />
  </div>

</template>

<script>
  import emailReport from './emailReport';
  export default emailReport;
</script>

<style scoped>
.w-full {
  width: 100%;
}
.min-h-screen {
  min-height: 100vh;
}

/* Responsive Grid Layout */
.grid {
  display: grid;
  gap: 1rem;
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1024px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .grid {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .searchButton{
    width: 100%;
  }
}

/* Card Styling */
.bg-white {
  background-color: white;
}

.p-4 {
  padding: 1rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.shadow-lg {
  box-shadow: 6px 6px 8px 12px rgba(0, 0, 0, 0.1);
}

.flex-grow {
  flex-grow: 1;
}
</style>
